import * as API from '../'
export default {
    // 平台名称配置列表
    dicApplicationList(param){
        return API.POST(process.env.baseAccountURL+'/dic/application/list', param);
      },
    // 平台名称配置新增
    dicApplicationSave(param){
        return API.POST(process.env.baseAccountURL+'/dic/application/save', param);
      },
    dicApplicationCheck(param){
        return API.POST(process.env.baseAccountURL+'/department/list', param);
      },
    //  获取默认平台名称
    dicApplicationGetname(param){
      return API.POST(process.env.baseAccountURL+'/dic/application/getname', param);
    },
    //  修改平台名称配置
    dicApplicationUpdate(param){
        return API.POST(process.env.baseAccountURL+'/dic/application/update', param);
      },
    //  获取应用名称 
    applicationDicDetail(param){
      return API.POST(process.env.baseAccountURL+'/dic/application/user/detail', param);
      
    },
    // 获取全部机构
    departmentAll(param){
      return API.POST(process.env.baseAccountURL+'/department/all', param);
    },
}


// WEBPACK FOOTER //
// ./src/api/configuration/api_configuration.js